import React, { useState, useEffect } from 'react';

const LAYER_GRADIENTS = [
  { from: '#26215C', to: '#3B3284' },
  { from: '#3B3284', to: '#534AB7' },
  { from: '#534AB7', to: '#7F77DD' },
  { from: '#7F77DD', to: '#AFA9EC' },
  { from: '#AFA9EC', to: '#EEEDFE' },
];

/**
 * ErmeneLoader — 5 ellissi verticali concentriche (forma brand Ermene).
 * Puramente grafico. Aspect ratio ~0.75 (rx < ry) coerente col logo header.
 */
export default function ErmeneLoader() {
  const [activeLayer, setActiveLayer] = useState(1);

  useEffect(() => {
    const interval = setInterval(() => {
      setActiveLayer(prev => (prev >= 5 ? 1 : prev + 1));
    }, 800);
    return () => clearInterval(interval);
  }, []);

  return (
    <div className="ermene-loader" role="status" aria-label="Elaborazione in corso">
      <svg
        viewBox="0 0 200 240"
        className="ermene-loader-svg"
        aria-hidden="true"
      >
        <defs>
          {LAYER_GRADIENTS.map((g, i) => (
            <linearGradient
              key={i}
              id={`ermene-loader-grad-${i + 1}`}
              x1="0%" y1="0%" x2="100%" y2="100%"
            >
              <stop offset="0%" stopColor={g.from} />
              <stop offset="100%" stopColor={g.to} />
            </linearGradient>
          ))}
          <linearGradient id="ermene-loader-core-grad" x1="0%" y1="0%" x2="0%" y2="100%">
            <stop offset="0%" stopColor="#EEEDFE" />
            <stop offset="100%" stopColor="#AFA9EC" />
          </linearGradient>
        </defs>
        {[1, 2, 3, 4, 5].map(layer => {
          const isActive = activeLayer === layer;
          const isLit = activeLayer >= layer;
          return (
            <ellipse
              key={layer}
              cx="100"
              cy="120"
              rx={15 + layer * 12}
              ry={20 + layer * 16}
              fill="none"
              stroke={isLit ? `url(#ermene-loader-grad-${layer})` : 'rgba(175,169,236,0.12)'}
              strokeWidth={isActive ? 2.5 : 1.8}
              className={isActive ? 'ermene-loader-ring-active' : 'ermene-loader-ring'}
              style={{
                transition: 'stroke-width 0.3s ease, stroke 0.3s ease',
              }}
            />
          );
        })}
        <ellipse
          cx="100" cy="120" rx="8" ry="12"
          fill="url(#ermene-loader-core-grad)"
          className="ermene-loader-core"
        />
      </svg>
    </div>
  );
}
